import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PriceType} from "../../types/price.type";
import {PricePlanService} from "../../services/price-plan-service.service";
import {ItemSetting} from "../../models/itemSetting.model";
import {ProgramLocationType} from "../../types/program-location.type";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {CustomerType} from "../../../customers/angular/types/customer-type.type";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";
import {PriceMethodType} from "../../types/price-method.type";
import {CustomersDialogService} from "../../../customers/services/customers-dialogs-service.service";
import {CustomerService} from "../../../customers/services/customers-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PricePlanRequestsService} from "../../services/price-plan-requests.service";

export class ProgramLocationsViewCtrl implements IController {

  programId: string;
  priceType: PriceType;
  accountId: string;

  private supportedPriceTypes: PriceType[];
  public isPriceTypeSupported: boolean;
  public locationTypeToIconMap = {
    ACCOUNT: 'account',
    DEPOT: 'depot',
    CUSTOMER: 'customer',
    AREA: 'service-area'
  }
  public accountIds: string[];
  public programData: any;
  public programTypeMap: typeof PriceType = PriceType;
  public packageItemOptions: ItemSetting[];
  public isSaveAvailable: boolean;
  public cardsEnabledByIdMap: Object = {};
  public excludeOriginIds: any[] = [];
  public excludeLocationIdsByOriginMap: Object = {};
  public packagesOptionsIds: string[] = [];
  public locationTypes: typeof ProgramLocationType = ProgramLocationType;
  public customerType: typeof CustomerType = CustomerType;

  constructor(private PricePlanService: PricePlanService, private confirmDialogService: ConfirmDialogService, private pricePlanRequestsService: PricePlanRequestsService, private pricePlanConstant,
              private pricePlanAlertsService: PricePlanAlertsService, private $filter, private $log, private customerService: CustomerService,
              private customersDialogService: CustomersDialogService, private pricePlanDialogService: PricePlanDialogService) {
    this.supportedPriceTypes = pricePlanConstant.availableProgramPriceTypesByMethod[PriceMethodType.Locations];
  }

  $onInit() {
    this.initValues();
  }

  initValues(){
    this.accountIds = this.accountId ? [this.accountId] : [];
    this.isPriceTypeSupported = this.supportedPriceTypes.includes(this.priceType);
    this._getProgramData();
    this._getProgramPackageOptions();
  }


  // onAddPackage(packageItem: ItemSetting) {
  //   const dataItem = {
  //     id: packageItem.id,
  //     text: packageItem.name,
  //     data: []
  //   }
  //
  //   if (!this.programData.areaData) {
  //     this.programData.areaData = [];
  //   }
  //
  //   this.programData.areaData.push(dataItem);
  //   this._setPackageItemOptions();
  //   // this._onDataChange()
  // }

  onAddOrigin($event) {
    this.excludeOriginIds = _.map(this.programData.areaData, 'id');
    const dataItem = {
      isView: true,
      id: undefined,
      text: undefined,
      entityType: ProgramLocationType.ACCOUNT,
      data: []
    }

    if (!this.programData.areaData) {
      this.programData.areaData = [];
    }

    this.programData.areaData.push(dataItem);
    this._onDataChange();
  }

  onOriginLocationTypeChange(areaData, locationType) {
    areaData.entityType = locationType;
    this._onDataChange();
  }

  onOriginLocationSelect(areaData, entity, locationType) {

    if (!entity) {
      return;
    }

    areaData.id = _.get(entity, 'id');

    if (locationType === this.locationTypes.AREA) {
      areaData.text = _.get(entity, 'areaName');
    } else if (locationType === this.locationTypes.CUSTOMER) {
      areaData.text = entity ? this.$filter('userName')(entity) : undefined;
    } else {
      areaData.text = _.get(entity, 'name');
    }

    this.cardsEnabledByIdMap[areaData.id] = true;
    this._onDataChange();
    this.onAddLocation(areaData)

  }

  onAddBulkLocations($event, areaData) {
    const excludeIds = this.excludeLocationIdsByOriginMap[areaData.id];
    this.pricePlanDialogService.addBulkLocations($event, areaData, excludeIds)
      .then((payload: {entityType,entities}) => {
        const entityType = payload.entityType;
        const entities = payload.entities;

        const dataItems = [];

        _.forEach(entities, (e) => {
          dataItems.push({
            name: entityType === ProgramLocationType.CUSTOMER ?
              (e.type === this.customerType.Private ? this.$filter('userName')(e) : e.businessName) :
              (entityType === ProgramLocationType.AREA ? _.get(e, 'areaName') : _.get(e, 'name')),
            fromId: areaData.id,
            fromEntityType: areaData.entityType,
            toId: e.id,
            toEntityType: entityType,
            combinedPackageSizePriceDataMap: {},
            parentAvailable: true
          });
        })

        if (!areaData.data) {
          areaData.data = [];
        }

        areaData.data = areaData.data.concat(dataItems);
        this._setExcludeLocationsMap();
        this._onDataChange();
      })
  }

  onAddLocation(areaData) {
    const dataItem = {
      name: undefined,
      fromId: areaData.id,
      fromEntityType: areaData.entityType,
      toId: undefined,
      toEntityType: ProgramLocationType.ACCOUNT,
      combinedPackageSizePriceDataMap: {},
      parentAvailable: true
    }

    if (!areaData.data) {
      areaData.data = [];
    }

    areaData.data.push(dataItem);
    this._onDataChange();

  }

  canDeleteOrigin(areaData) {
    let canDeleteOrigin = true;

    _.forEach(areaData.data, (d) => {
      const canDeleteRow = !_.find(d.combinedPackageSizePriceDataMap, (packageValue) => {
        return _.isBoolean(packageValue.parentEnabled);
      })
      if (!canDeleteRow) {
        canDeleteOrigin = false;
        return;
      }
    })

    return canDeleteOrigin;
  }

  onDeleteOrigin(areaData, $index) {
    if ($index > -1) {
      const text = 'Are you sure you want to delete this origin?';
      this.confirmDialogService.confirm('Delete Origin', text)
        .then(() => {
          if (!!this.programData.areaData[$index].isView) {
            this._removeViewOrigin($index);
            this._onDataChange();
          } else {
            this.PricePlanService.deleteRelationPricePlanPreferences(this.programId, areaData.id)
              .then(() => {
                this._removeViewOrigin($index);
              })
            // SERVER API REMOVE ORIGIN
          }
        })
    }
  }

  onDeleteLocation(location, areaDataIndex) {
    if (_.some(location.combinedPackageSizePriceDataMap)) {
      this.confirmDialogService.confirm('Has Packages', 'Are you sure you want to delete this location with packages?')
        .then(() => {
          this._onDeleteLocation(location, areaDataIndex);
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    } else {
      this._onDeleteLocation(location, areaDataIndex);
    }
  }

  onUpdateLocation(location, index, areaData) {
    areaData.data[index] = location;
    this._setExcludeLocationsMap();
    this._onDataChange();
  }

  onBulkEditPackages() {
    let packagesOptionsIds = [];
    _.forEach(this.programData.areaData, (a) => {
      _.forEach(a.data, (d) => {
        const keys = _.keys(d.combinedPackageSizePriceDataMap);
        packagesOptionsIds = _.uniq(packagesOptionsIds.concat(keys));
      })
    })


    this.pricePlanDialogService.bulkEditPackages(packagesOptionsIds)
      .then((payload: {packagesIds, sumType, isPercent, price, programState}) => {
        _.forEach(this.programData.areaData, (a) => {
          _.forEach(a.data, (d) => {
            _.forOwn(d.combinedPackageSizePriceDataMap, (value, key) => {

              // Program State
              if (payload.programState !== 'NO_CHANGE') {
                value.enabled = payload.programState;
              }

              // Do nothing if
              if (!payload.price || (!!payload.packagesIds?.length && !_.includes(key, payload.packagesIds))) {
                return;
              }

              let basePrice = payload.sumType === '+' ?
                (value.basePrice + (payload.isPercent ? (payload.price * value.basePrice / 100) : payload.price)) :
                payload.sumType === '-' ?
                  (value.basePrice - (payload.isPercent ? (payload.price * value.basePrice / 100) : payload.price)) :
                  payload.price;

              value.basePrice = basePrice < 0 ? 0 : basePrice;
            })
          })
        })

        this._onDataChange();
        // this.onUpdateLocation(updatedLocation, index, areaData);
      })
  }

  onBulkEditLocation(location, index, areaData) {
    this.pricePlanDialogService.bulkEditLocationPackages(location)
      .then((updatedLocation) => {
        this.onUpdateLocation(updatedLocation, index, areaData);
      })
  }

  onCreateCustomerForLocation(location, index, areaData) {
    this.customersDialogService.createCustomer(undefined, undefined, this.accountId)
      .then((customerToCreate) => {
        this._createCustomerForLocation(customerToCreate, location, index, areaData);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onSaveProgram(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {

        const originWithoutLocation = _.find(this.programData.areaData, (areaData) => {
          return !areaData.data.length
        })

        if (!!originWithoutLocation) {
          this.pricePlanAlertsService.updatePreferencesOriginMissingLocationsWarning(originWithoutLocation)
          return;
        }

        this.PricePlanService.editProgramConfiguration(this.programId, this.programData, this.accountId)
          .then((programData) => {
            this.programData = programData;
            this.isSaveAvailable = false;
          })
      }
    }
  }

  onCancelChanges(){
    this.initValues();
    this.isSaveAvailable = false;
  }

  private _getProgramData() {
    this.PricePlanService.getProgramData(this.programId, this.accountId, undefined, undefined, true)
      .then((programData: any) => {
        this.programData = programData;
        this._setExcludeLocationsMap();
      })
  }

  private _getProgramPackageOptions() {
    this.pricePlanRequestsService.getPricePlanPreferences(this.programId, ['PackageSize'], this.accountId)
      .then((res) => {
        this.packagesOptionsIds = _.chain(_.get(res, 'data[0].value', []))
          .filter((packageItem) => {
            return _.isUndefined(packageItem.enabled) ? !!packageItem.parentEnabled : !!packageItem.enabled;
            // return !!packageItem.enabled || !!packageItem.parentEnabled
          })
          .map('id')
          .value();
      })
  }

  private _removeViewLocation(location, areaDataIndex, isSaveAvailable) {
    const locationIndex = _.findIndex(this.programData.areaData[areaDataIndex].data, (l: any) => {
      return l.toId === location.toId;
    })

    if (locationIndex > -1) {
      const areaDataCopy = angular.copy(this.programData.areaData[areaDataIndex]);
      areaDataCopy.data.splice(locationIndex, 1);

      this.programData.areaData[areaDataIndex] = areaDataCopy;

      this._setExcludeLocationsMap();
      this.isSaveAvailable = isSaveAvailable;
    }
  }

  private _removeViewOrigin(index) {
    const areaDataCopy = angular.copy(this.programData.areaData);
    areaDataCopy.splice(index, 1);

    this.programData.areaData = areaDataCopy;
  }

  private _onDataChange(value?) {
    this.isSaveAvailable = _.isUndefined(value) ? true : value;
  }

  private _onDeleteLocation(location, areaDataIndex) {
    if (location.id) {
      this.PricePlanService.deleteRelationPricePlanPreferences(this.programId, location.fromId, location.toId)
        .then(() => {
          this._removeViewLocation(location, areaDataIndex, false);
          this._onDataChange(false);
        })
    } else {
      this._removeViewLocation(location, areaDataIndex, true);
      this._onDataChange(true)
    }
  }

  private _createCustomerForLocation(customer, location, index, areaData) {
    this.customerService.createCustomer(customer)
      .then((createdCustomer) => {
        location.toId = _.get(createdCustomer, 'id');
        location.name = createdCustomer ? (createdCustomer.type === CustomerType.Business ? createdCustomer.businessName : this.$filter('userName')(createdCustomer)) : undefined;
        this.onUpdateLocation(location, index, areaData);
      })
  }

  private _setExcludeLocationsMap() {
    this.excludeLocationIdsByOriginMap = {};
    _.forEach(this.programData.areaData, (areaData) => {
      this.excludeLocationIdsByOriginMap[areaData.id] = areaData.data
        .filter(a => {return !!a.toId})
        .map(a => {return a.toId})
    })
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationsView', {
    bindings: {
      programId: '<',
      priceType: '<',
      accountId: '<?'
    },
    template: require('./program-locations-view.html').default,
    controller: ProgramLocationsViewCtrl
  });
